import { render, staticRenderFns } from "./AppDashboardApps.vue?vue&type=template&id=bd1263ae&scoped=true&"
import script from "./AppDashboardApps.vue?vue&type=script&lang=js&"
export * from "./AppDashboardApps.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd1263ae",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemGroup } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VScrollXTransition } from 'vuetify/lib/components/transitions';
installComponents(component, {VBtn,VCard,VDataTable,VIcon,VList,VListItem,VListItemContent,VListItemGroup,VListItemTitle,VMenu,VScrollXTransition})
